import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M2.832 14H7v5.799c0 .98 1.264 1.375 1.822.569l1.328-1.919a7.003 7.003 0 0 1 4.692-8.11.98.98 0 0 0-.75-.34H10V3.406c0-.998-1.301-1.38-1.841-.541L1.99 12.459A1 1 0 0 0 2.83 14"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17 22a5 5 0 1 0 0-10 5 5 0 0 0 0 10m0-8a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1",
      clipRule: "evenodd"
    }
  )
);
var SvgPowerDialerAddFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PowerDialerAddFilled_default = SvgPowerDialerAddFilled;

export { PowerDialerAddFilled_default as default };
